import { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { useParams } from 'react-router'
import { useGetStep } from 'shared/hooks'
import { StepsCommonLayout } from 'pages/settings/ui/StepsCommonLayout/StepsCommonLayout'
import { type TollFreeRoutesSteps } from 'pages/settings/pages/compliance/pages/tollFree/route/type'
import { useTollFreeStepsContext } from 'pages/settings/pages/compliance/pages/tollFree/context/tollFreeStepsContext'
import { useProgressInfoTitle } from 'pages/settings/pages/compliance/pages/tollFree/hooks/useProgressInfoTitle'

export const TollFreeStepsLayout = observer(() => {
  const { useCaseNumber } = useParams()

  const {
    closeSetting,
    setTollFreeData,
    numbersStore,
    initNumbersStore,
    tollFreeNavigationStore: {
      allStepsLength,
      tollFreeStepsStore,
      decreaseStep,
      setCurrentStep,
      getSettingsStep,
    },
  } = useTollFreeStepsContext()
  const settingsStep = useGetStep<TollFreeRoutesSteps>(getSettingsStep)
  const infoTitle = useProgressInfoTitle()

  useEffect(() => {
    if (numbersStore.isInitialized) return

    initNumbersStore()
    setTollFreeData(useCaseNumber)
  }, [])

  useEffect(() => {
    setCurrentStep(settingsStep)
  }, [settingsStep])

  const closeSettingHandler = async () => {
    await closeSetting()
    tollFreeStepsStore.useCaseDetailsStore.setActiveNumber(null)
  }

  return (
    <StepsCommonLayout
      progressTitle={infoTitle}
      totalSteps={allStepsLength}
      title='Toll-free verification'
      settingsStep={settingsStep}
      closeSetting={closeSettingHandler}
      decreaseStep={decreaseStep}
    />
  )
})
